module.exports = __webpack_public_path__ + "static/img/iconfont.253c05b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.svg?t=1487055721860
// module id = 112
// module chunks = 2